// extracted by mini-css-extract-plugin
export default {"scroll":"vertical-scroll_scroll__GZuAV"};